
import { Alert,  Card, Table, Modal, Accordion, Form } from 'react-bootstrap';
import {Sida,Rubrik,ContentWrapper,Button} from "../ContentStyles";
import useBackend, {CallAPI, Loading, SpinnerX} from '../../services/useBackend';
import {MaterialReactTable} from 'material-react-table';
import React, { useState ,useEffect, useReducer, fetchData,useMemo} from 'react';
import {DateTimeToLocal, MultiselectGetOptions, MultiselectGetDefaultValues, escapedNewLineToLineBreakTag, ConcatLocalDateAndTime2ISO, SplitoutLocalDateFromISO, SplitoutLocalTimeFromISO, getOptions, metaLookUpTitle} from '../../services/misc';

const WFItems = () => {
    const [saving,        setSaving]        = useState(false);
    const [resultVariant, setResultVariant] = useState('warning');
    const [resultText,    setResultText]    = useState('N/A');
    const [resultVisible, setResultVisible] = useState(false);  
    const [editWFItemModalshow, setEditWFItemModalshow] = useState(false);

    const [selectedWFItemData, setSelectedWFItemData] = useState({});

    const {loading:loadingmeta, data:metadata, Refresh} =  useBackend(process.env.PUBLIC_URL+'/api/meta');

    const editWFItemHandler = async (event, rowData)  =>  {
        setSelectedWFItemData(rowData.original)
        setEditWFItemModalshow(!editWFItemModalshow);
        setResultVisible(false);
    }

    async function handleSave(){
        setSaving(true);
        setResultText("");
        setResultVisible(false);

        const FrmWFItem = document.getElementById('FrmWFItem');
        const formData = new FormData(FrmWFItem);
        const formDataObj = Object.fromEntries(formData.entries());

        let {resultVariant, resultVisible, resultText, errorsException} = await CallAPI('/api/meta/WFItem/'+selectedWFItemData.Guid,"PUT",JSON.stringify(formDataObj));
        setResultVariant(resultVariant);   
        setResultText(resultText);
        setResultVisible(true);
        Refresh();
        setSaving(false);
    }    

    const SaveNewContactHandler = (event)  =>  {
      handleSave();
    }    
   
    const columns = useMemo(() => [
            { size: 40, accessorKey: 'Name',         header: 'Name',     enableColumnActions: false },

            { size: 20, header: 'UserCategory', enableColumnActions: false,
                Cell: ({ row }) => ( <span>{metaLookUpTitle(metadata.UserCategories, row.original.UserCategoriesID)}</span> ),
            }, 
            
            { size: 40, accessorKey: 'name_short', header: 'name_short',  enableColumnActions: false },         
        ]
    );

    const initialState = { density: 'compact', columnVisibility: { } };    

    if (!loadingmeta) {
        return (
            <ContentWrapper>
                    <Modal show={editWFItemModalshow} onHide={()=>setEditWFItemModalshow(false)} size='xl'>
                        <Modal.Header closeButton>
                            <Modal.Title>WF Item</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <Form id='FrmWFItem' name='AddWFForm'>
                                <Form.Group className="mb-3" >
                                    <Form.Label>Name</Form.Label>
                                    <Form.Control type="text" value={selectedWFItemData.Name} disabled id="newstep_misc01" placeholder="" />
                                </Form.Group>

                                <Form.Group className="mb-3" >
                                    <Form.Label>Short Name</Form.Label>
                                    <Form.Control type="text" value={selectedWFItemData.name_short} disabled id="newstep_misc01" placeholder="" />
                                </Form.Group>

                                <Form.Group className="mb-3" >
                                    <Form.Label>User Category</Form.Label>
                                    <Form.Select name="UserCategoryId" id="UserCategoryId" defaultValue={selectedWFItemData.UserCategoriesID}>
                                        {getOptions(metadata.UserCategories)}
                                    </Form.Select>
                                </Form.Group>

                                <Form.Group className="mb-3"  hidden={!resultVisible}>
                                    <Alert show={resultVisible} variant={resultVariant}  className="FormSpace">{resultText}</Alert>
                                </Form.Group>

                                <Form.Group className="mb-3" >
                                    <Button className="QmeButton" variant="primary" type="button" onClick={() => {SaveNewContactHandler()} } >Save</Button>
						        </Form.Group>
                            </Form>
                        </Modal.Body>
                    </Modal>
                    <Sida>
                        <MaterialReactTable  columns={columns} data={metadata.RequestWFItems} initialState={initialState} enablePagination={false}
                            muiTablePaginationProps={{ showFirstButton: false, showLastButton: false, rowsPerPageOptions: [100, 200] ,labelRowsPerPage:"Rader"}}
                            renderTopToolbarCustomActions={() => (<Rubrik>WFItems</Rubrik>)}                            
                            muiTablePaperProps={{elevation: 0, sx: {borderRadius: '0',border: '0px dashed #e0e0e0'} }} 
                            muiTableBodyRowProps={({ row }) => ({ onClick: (event) => {editWFItemHandler(event, row);},sx: {cursor: 'pointer'},})}
                        />
                    </Sida>
            </ContentWrapper>  
        );
    } else {
        return (<Loading />);        
    }      
};

export default WFItems;